"use strict";

var React = require("react");

var SvgIconChevronUpV1 = function SvgIconChevronUpV1() {
  return /*#__PURE__*/ React.createElement(
    "svg",
    {
      width: "1em",
      height: "1em",
    },
    /*#__PURE__*/ React.createElement("path", {
      fill: "currentColor",
      d: "M1.186 7.907l-1.16-1.1L5 2.093l4.975 4.714-1.16 1.1L5 4.293z",
    })
  );
};

exports["foreignIcon"] = SvgIconChevronUpV1;
